import React from 'react';
import './Testimonial.css';

const Testimonials = () => {
    const testimonials = [
        {
          id: 1,
          text: "My stay at Nimantrana was truly unforgettable. The rooms were elegant, the service was impeccable, and every little detail was thoughtfully curated.",
          name: "Rohit Mehra",
          position: "Business Consultant from Delhi",
          image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/testimonial1.png"
        },
        {
          id: 2,
          text: "Nimantrana blends traditional Indian hospitality with modern luxury. From the warm welcome to the gourmet dining, everything was top-notch.",
          name: "Ananya Iyer",
          position: "Travel Blogger from Chennai",
          image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/testimonial2.png"
        },
        {
          id: 3,
          text: "I’ve stayed at many luxury hotels, but Nimantrana stands out for its peaceful ambience and exceptional staff. Highly recommended for a relaxing getaway.",
          name: "Kabir Malhotra",
          position: "Entrepreneur from Mumbai",
          image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/testimonial3.png"
        },
        {
          id: 4,
          text: "Whether it was the spacious rooms, beautiful decor, or the attention to detail, Nimantrana exceeded all my expectations. A five-star experience!",
          name: "Sneha Kapoor",
          position: "Fashion Designer from Bengaluru",
          image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/testimonial4.png"
        },
        {
          id: 5,
          text: "The staff at Nimantrana treated us like royalty. It’s the perfect place for both business and leisure stays. Can’t wait to return!",
          name: "Arjun Verma",
          position: "IT Executive from Hyderabad",
          image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/testimonial5.png"
        },
        {
          id: 6,
          text: "From sunrise yoga sessions to candlelit dinners, every moment at Nimantrana felt magical. It’s not just a hotel, it’s an experience.",
          name: "Priya Sharma",
          position: "Wellness Coach from Pune",
          image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/testimonial6.png"
        }
      ];
      

  // Duplicate testimonials for seamless loop
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <div className='testimonialsContainer'>
      <div className='testimonialsHeadingContainer'>
        <p>Testimonials</p>
      </div>
      <div className='testimonialDescContainer'>
        <p>Don't take our word for it. <br/> <span style={{color:'#DCB15D'}}>Over 500+ people trust us.</span></p>
      </div>
      
      <div className='testimonialsCarouselWrapper'>
        <div className='testimonialsCarousel'>
          <div className='testimonialsTrack'>
            {duplicatedTestimonials.map((testimonial, index) => (
              <div key={`${testimonial.id}-${index}`} className='testimonialCard'>
                <div className='testimonialContent'>
                  <p className='testimonialText'>{testimonial.text}</p>
                </div>
                <div className='testimonialAuthor'>
                  <div className='authorImage'>
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <div className='authorInfo'>
                    <h4 className='authorName'>{testimonial.name}</h4>
                    <p className='authorPosition'>{testimonial.position}</p>
                  </div>
                </div>
                <div className='testimonialRating'>
                  <div className='stars'>
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className='star'>★</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        
      </div>
    </div>
  );
};

export default Testimonials;